import { number, string } from 'prop-types';

const tripExpenseBasicInformationPropTypes = {
  documentSeries: string.isRequired,
  documentCode: string.isRequired,
  date: number.isRequired,
  driverFullName: string.isRequired,
  companyBusId: string.isRequired,
  itinerarySourceAndDestination: string.isRequired,
  tollPayment: number.isRequired,
  commissionPayment: number.isRequired,
  totalPayment: number.isRequired,
  otherPayment: number.isRequired,
};

export default tripExpenseBasicInformationPropTypes;
